import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { DashboardTable } from './DashboardTable.js';
import { actions } from './DashboardTable.actions';
import {
    mainSelector,
    getHeaderName,
    getMetrics
} from './DashboardTable.selectors';

const mapStateToPropsSelectors = createStructuredSelector({
    headerName: getHeaderName,
    data: mainSelector,
    metrics: getMetrics
});

const DashboardTableComponent = connect(
    function mapStateToProps(state) {
        return {
            ...mapStateToPropsSelectors(state),
            loading: state.dashboard.last.loading
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            getLastData: actions.getLastData,
            clear: () => dispatch(actions.clear())
        };
    }
)(DashboardTable);

export default DashboardTableComponent;
